/** 404 applicative — l’adresse ne correspond à aucun écran. */

import { Link } from 'react-router'

import { useSession } from '../auth'
import { CHEMINS } from '../lib/chemins'
import { classesBouton } from '../ui/Button'
import { EmptyState } from '../ui/EmptyState'

export function PageIntrouvable() {
  const session = useSession()
  const destination =
    session === null
      ? CHEMINS.racine
      : session.sujet === 'staff'
        ? CHEMINS.admin
        : CHEMINS.portail

  return (
    <main className="flex min-h-dvh items-center justify-center bg-slate-50 px-4">
      <EmptyState
        titre="Page introuvable"
        description="Cette adresse ne correspond à aucun écran. Le lien est peut-être ancien, ou l’écran a changé de nom."
        action={
          <Link to={destination} className={classesBouton('primaire')}>
            Retour
          </Link>
        }
      />
    </main>
  )
}
